import { CardProfile } from "./CardProfile";
import { CardActions } from "./CardActions";
import { ContactList } from "./ContactList";

const FALLBACK = { bg: "#262626", fg: "#F7F7F7", accent: "#7EC9C9", accent_fg: "#262626", logo: "white" };

const isDark = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  return ((n >> 16) * 299 + ((n >> 8) & 255) * 587 + (n & 255) * 114) / 1000 < 150;
};

const themeFor = (card, config, d) => {
  if (d?.colors === "custom") return { bg: d.bg, fg: d.fg, accent: d.accent, accent_fg: d.accent_fg, logo: isDark(d.bg) ? "white" : "black" };
  return config?.themes?.[card.theme] || config?.themes?.["inception-black"] || FALLBACK;
};

export const CardView = ({ card, config, design }) => {
  const d = design || config?.profile_design;
  const theme = themeFor(card, config, d);
  return (
    <div className="space-y-5" data-testid="card-view">
      <div className="rise" style={{ animationDelay: "0ms" }}><CardProfile card={card} theme={theme} layout={d?.layout} shape={d?.photo_shape} bgImage={card.bg_image ? d?.bg_image_url : ""} overlay={d?.bg_overlay ?? 45} /></div>
      <div className="rise" style={{ animationDelay: "90ms" }}><CardActions card={card} theme={theme} /></div>
      <div className="rise" style={{ animationDelay: "180ms" }}><ContactList card={card} /></div>
    </div>
  );
};
